module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-body col-sm-8 col-sm-offset-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn bg-pink-400 btn-block",
    on: {
      "click": _vm.processReg
    }
  }, [_vm._v("Register "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right position-right"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "icon-object border-slate-300 text-slate-300"
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  })]), _vm._v(" "), _c('h5', {
    staticClass: "content-group"
  }, [_vm._v("New customer "), _c('small', {
    staticClass: "display-block"
  }, [_vm._v("Enter new credentials below")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-feedback"
  }, [_c('i', {
    staticClass: "fa fa-user text-muted"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-feedback"
  }, [_c('i', {
    staticClass: "fa fa-lock text-muted"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d28d385","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 358
// module chunks = 0